import React, { CSSProperties, FunctionComponent } from 'react';
import { PageFooter } from '../../core/formBuilder/usePages';
import SegmentedLayout from './segments/segmentedLayout';
import { Box } from '@mui/material';

interface FooterProps {
  footer: PageFooter;
  isMobile: boolean;
  styles?: CSSProperties;
}

export const Footer: FunctionComponent<FooterProps> = ({
  footer,
  isMobile,
  styles,
}) => {
  return (
    <>
      <Box className="footer" style={styles}>
        <SegmentedLayout
          segments={footer.segments}
          isMobile={isMobile}
          height={footer.height}
        />
      </Box>
    </>
  );
};
